module.exports = __webpack_public_path__ + "static/img/ndvi_9.313048ea.jpg";